const translations = {
    wet: 'Spray'
};

export default translations;
